import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import Services from "./Pages/Services";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import New from "./Pages/New";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Shop from "./Pages/Shop"; // 👈 import the Shop page
import MobileTopup from "./Pages/MobileTopup";
import MMG from "./Pages/MMG";
import Bills from "./Pages/Bills";
import Ferry from "./Pages/Ferry";
import Business from "./Pages/Business";
import Insurance from "./Pages/Insurance";
import Investors from "./Pages/Investors";
import OtherServices from "./Pages/OtherServices";
import Checkout from "./Pages/Checkout";
import CheckoutSuccess from "./Pages/Checkoutsuccess";
import MMGCheckout from "./Pages/MMGCheckout";
import Success from "./Pages/Success";
import Error from "./Pages/Error";

const App = () => {
  return (
    <Router>
      <div className="app-container">
      <Header />

      <main className="page-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/new" element={<New />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/services/topup" element={<MobileTopup />} />
            <Route path="/services/mmg" element={<MMG />} />
            <Route path="/services/bills" element={<Bills />} />
            <Route path="/services/ferry" element={<Ferry />} />
            <Route path="/services/business" element={<Business />} />
            <Route path="/services/insurance" element={<Insurance />} />
            <Route path="/services/investors" element={<Investors />} />
            <Route path="/services/others" element={<OtherServices />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout-success" element={<CheckoutSuccess />} />
            <Route path="/mmg-checkout" element={<MMGCheckout />} />
            <Route path="/mmg/success" element={<Success />} />
            <Route path="/mmg/error" element={<Error />} />
          </Routes>

          <ToastContainer
            position="top-center"     // ✅ Centered at the top
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
